import React, { useEffect, useState } from "react";
import { FETCH_APPLICATION_TRANSACTIONS_URL } from "../../../../app/constants";
import { PaymentHistoryDetails } from "./PaymentHistory/PaymentHistoryDetails";
import { PaymentHistoryTable } from "./PaymentHistory/PaymentHistoryTable";

export const PaymentHistoryTab = (props) => {
    const {isArchiveApplication, licenceApplication} = props
    const [paymentHistory, setPaymentHistory] = useState([]);
    let qItemId = licenceApplication.id

    if(isArchiveApplication) {
        qItemId = licenceApplication.originalApplicationId
    }
    
    useEffect(() => {
        const fetchPaymentHistory = async () => {
            const resp = await fetch(`${FETCH_APPLICATION_TRANSACTIONS_URL}?businessApplicationId=${parseInt(qItemId)}`)
            const data = await resp.json()
            if(Array.isArray(data) && data.every((val) => !!val)) {
                setPaymentHistory(data)
            } else {
                setPaymentHistory([])
            }
        }
        fetchPaymentHistory()
    }, [qItemId])

    const [details, setDetails] = useState()

    // if(paymentHistory === "loading") {
    //     return null;
    // }

    return details
        ? <PaymentHistoryDetails details={details} setDetails={setDetails} />
        : <PaymentHistoryTable data={paymentHistory} setDetails={setDetails} />
}
